@if (!access) {
  <div class="slider-bottom hidden-print" #slider>
    <div class="slider-content">
      <button type="button" (click)="allowAccess()" class="cancel slider-button">x</button>
      <div class="slider-text">
        <h2>{{ 'We use cookies on this site to enhance your experience.' | translate }}</h2>
        <p [innerHTML]="'cookie_consent_text' | translate"></p>
      </div>
    </div>
  </div>
}